import React from 'react'
import classes from "./CostcallPage.module.scss"
import Header from '../../components/GlobalComponents/Header/Header'
import First from '../../components/CostcallPage/First/First'
import Second from '../../components/CostcallPage/Second/Second'
import Third from '../../components/CostcallPage/Third/Third'
import Fourth from '../../components/CostcallPage/Fourth/Fourth'
import Fifth from '../../components/CostcallPage/Fifth/Fifth'
import Sixth from '../../components/CostcallPage/Sixth/Sixth'
import Seventh from '../../components/CostcallPage/Seventh/Seventh'
import Footer from '../../components/GlobalComponents/Footer/Footer'

const CostcallPage = () => {
    return (
        <div className={[classes.costcall, ""].join(" ")}>
            <Header />
            <First />
            <Second />
            <Third />
            <Fourth />
            <Fifth />
            <Sixth />
            <Seventh />
            <Footer />
        </div>

    )
}

export default CostcallPage